"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicFormSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '500px',
  height: '100%',
  maxWidth: '100%',
  minWidth: '330px',
  zIndex: 50,
  left: '50%',
  transform: 'translateX(-50%)',
  background: '#fff',
  [theme.breakpoints.up('md')]: {
    width: '330px'
  }
}));
const FormField = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  width: '100%',
  minHeight: '55px',
  borderRadius: '5px',
  marginBottom: theme.spacing(4)
}));
const StyledButton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  width: '100%',
  minHeight: '50px',
  borderRadius: '25px',
  marginTop: theme.spacing(3)
}));
const BasicFormSkeleton = ({
  skeletonConfig
}) => {
  const isAddressEnabled = skeletonConfig?.address?.operations?.read?.isEnabled ?? false;
  const useAddressConfig = isAddressEnabled ? skeletonConfig?.address : {};
  const usedConfigs = [{
    ...skeletonConfig?.contactDetails
  }, {
    ...skeletonConfig?.personalDetails
  }, {
    ...skeletonConfig?.identityDetails
  }, {
    ...skeletonConfig?.sponsorDetails
  }, {
    ...useAddressConfig
  }];
  const availableFieldsArrays = usedConfigs.map(usedConfig =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return --- we don`t know which type is return
  Object.values(usedConfig).filter(usedConfigObj => usedConfigObj.hasOwnProperty('isAvailable') && usedConfigObj.isAvailable === true));
  const availableFields = availableFieldsArrays.flat();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    children: [availableFields.map((_af, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(FormField
    // eslint-disable-next-line react/no-array-index-key -- we need use index because, we dont have unique key
    , {
      variant: "rectangular"
    }, `available-skeleton-field-${index}`)), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButton, {
      variant: "rectangular",
      animation: "wave"
    })]
  });
};
exports.BasicFormSkeleton = BasicFormSkeleton;
//# sourceMappingURL=BasicFormSkeleton.js.map